module.exports = __webpack_public_path__ + "static/media/close-square.8a81cf51.svg";